import React from 'react';

const T = {
  gold:'#b8860b', goldLt:'#d4a017',
  card:'#ffffff', card2:'#f7f9fc',
  border:'#e8edf5', border2:'#c8d0e0',
  text:'#1a2233', muted:'#5a6a88', dim:'#9aa3b8',
  navy:'#1a2a4a',
  green:'#1a7a4a', red:'#c0392b', teal:'#0e8a78', blue:'#1a5fa8',
  bg:'#f8f9fb', surface:'#ffffff',
  font:"'Plus Jakarta Sans',sans-serif",
};
export { T };

export function Logo({ branding, size='sm' }) {
  const big  = size === 'lg';
  const motto = branding?.motto || 'Navigate your path to success.';
  const imgSrc = branding?.logo_url || '/logo.png';
  return (
    <div style={{ display:'flex', alignItems:'center', gap: big?12:8 }}>
      <img
        src={imgSrc}
        alt="IELTS Compass"
        style={{ height: big?48:34, objectFit:'contain', borderRadius:6, flexShrink:0 }}
      />
      <div>
        <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:big?24:16, fontWeight:700, color:'#1a2a4a', lineHeight:1.05 }}>
          IELTS<span style={{color:'#b8860b'}}>COMPASS</span>
        </div>
        <div style={{ fontSize:big?11.5:9.5, color:'#5a6a88', marginTop:1 }}>{branding?.tagline||'with Mr. Ahmed Salem'}</div>
        {big && <div style={{ fontSize:12, color:'#b8860b', fontStyle:'italic', marginTop:2 }}>{motto}</div>}
      </div>
    </div>
  );
}

export function TopNav({ branding, onBack, backLabel, onLogoClick, right }) {
  return (
    <div style={{ background:'#ffffff', borderBottom:'1px solid #dde3ed', padding:'10px 20px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:200, boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        {onBack && (
          <button onClick={onBack} style={{ background:'transparent', border:'1px solid #c8d0e0', color:'#5a6a88', padding:'5px 12px', borderRadius:6, fontSize:12, cursor:'pointer', minHeight:36 }}>
            ← {backLabel||'Back'}
          </button>
        )}
        <div style={{ cursor: onLogoClick ? 'pointer' : 'default' }} onClick={onLogoClick}>
          <Logo branding={branding}/>
        </div>
      </div>
      {right && <div style={{ display:'flex', alignItems:'center', gap:8 }}>{right}</div>}
    </div>
  );
}

export function Footer({ branding }) {
  const imgSrc = branding?.logo_url || '/logo.png';
  return (
    <div style={{ background:'#1a2a4a', padding:'14px 20px', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:8, marginTop:'auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
        <div style={{ background:'rgba(255,255,255,0.12)', borderRadius:7, padding:'3px 6px', display:'flex', alignItems:'center' }}>
          <img src={imgSrc} alt="IELTS Compass" style={{ height:26, objectFit:'contain' }}/>
        </div>
        <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:14, fontWeight:700, color:'#fff' }}>IELTS<span style={{color:'#b8860b'}}>COMPASS</span></div>
      </div>
      <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
        {[branding?.phone1||'00201008182425', branding?.phone2||'00971565727742'].map(p=>(
          <span key={p} style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, color:'rgba(255,255,255,0.65)' }}>📞 {p}</span>
        ))}
      </div>
    </div>
  );
}

export function TierBadge({ tier }) {
  const map = { trial:['#e8f5ee','#1a7a4a'], standard:['#e8f0fb','#1a5fa8'], premium:['#fdf3e0','#b8860b'] };
  const [bg,color] = map[tier]||map.trial;
  return <span style={{ background:bg, color, fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.1em', padding:'3px 10px', borderRadius:100, textTransform:'uppercase', fontWeight:600, border:`1px solid ${color}33` }}>{tier}</span>;
}

export function BandBadge({ band }) {
  const n = parseFloat(band);
  const color = n>=7.5?'#1a7a4a':n>=7?'#3a7a10':n>=6.5?'#b8860b':n>=6?'#b8620a':'#c0392b';
  return <span style={{ background:color, color:'#fff', fontFamily:"'JetBrains Mono',monospace", fontSize:12, fontWeight:700, padding:'4px 14px', borderRadius:100 }}>Band {band}</span>;
}

export function Btn({ children, onClick, variant='default', disabled, style={}, small }) {
  const base = { border:'none', borderRadius:10, cursor:disabled?'default':'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", fontWeight:500, padding:small?'6px 14px':'10px 20px', fontSize:small?12:13.5, transition:'all .15s', opacity:disabled?.55:1, ...style };
  const variants = {
    default:{ background:'#f7f9fc', border:'1px solid #e8edf5', color:'#5a6a88' },
    primary:{ background:'linear-gradient(135deg,#b8860b,#d4a017)', color:'#ffffff', boxShadow:'0 2px 8px rgba(184,134,11,0.3)' },
    danger: { background:'transparent', border:'1px solid rgba(192,57,43,0.4)', color:'#c0392b' },
  };
  return <button onClick={disabled?undefined:onClick} style={{...base,...variants[variant]}}>{children}</button>;
}

export function Card({ children, style={}, accent }) {
  return (
    <div style={{ background:'#ffffff', border:'1px solid #e8edf5', borderRadius:14, padding:'20px', borderLeft:accent?`3px solid ${accent}`:undefined, boxShadow:'0 2px 12px rgba(26,42,74,0.07)', ...style }}>
      {children}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div style={{ marginBottom:12 }}>
      <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.14em', textTransform:'uppercase', color:'#5a6a88', marginBottom:5 }}>{label}</div>
      {children}
    </div>
  );
}

export function InputField({ value, onChange, placeholder, type='text', style={} }) {
  return (
    <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
      style={{ width:'100%', background:'#f7f9fc', border:'1px solid #c8d0e0', borderRadius:7, padding:'9px 13px', color:'#1a2233', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none', ...style }} />
  );
}

export function TextareaField({ value, onChange, placeholder, rows=3, style={} }) {
  return (
    <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows}
      style={{ width:'100%', background:'#f7f9fc', border:'1px solid #c8d0e0', borderRadius:7, padding:'9px 13px', color:'#1a2233', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none', resize:'vertical', lineHeight:1.65, ...style }} />
  );
}

export function MonoLabel({ children, color, style={} }) {
  return <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.16em', textTransform:'uppercase', color:color||'#5a6a88', ...style }}>{children}</div>;
}

export function Alert({ children, type='warning' }) {
  const map = { warning:['#b8620a','#fff8f0','#fde8cc'], danger:['#c0392b','#fff5f5','rgba(192,57,43,0.15)'], info:['#1a5fa8','#f0f6ff','#d0e4f8'], success:['#1a7a4a','#f0faf4','#c8ead8'] };
  const [color,bg,border] = map[type]||map.warning;
  return (
    <div style={{ background:bg, border:`1px solid ${border}`, borderRadius:8, padding:'10px 14px', fontSize:12.5, color, lineHeight:1.6, marginBottom:14 }}>
      {children}
    </div>
  );
}
